import { environment } from "environments/environment";

export const locale = {
  lang: "ca",
  data: {
    MENU: {
      EXAMPLE: "Exemple",
      TABLE: "Taula",
      FORM: "Formulari",
    },
    GENERAL: {
      FILTERS: "Filtres",
      RESET_FILTERS: "Reiniciar filtres",
      LOADING: "Carregant...",
      ADD: "Afegir",
      EDIT: "Editar",
      DELETE: "Eliminar",
      ERROR: "Error",
      RECOVER_DATA_ERR: "No s'han pogut recuperar les dades",
      CODE: "Codi",
      DAY: "Dia",
      DESCRIPTION: "Descripció",
      ACTIONS: "Accions",
      OK: "OK",
      CANCEL: "Cancelar",
      CORRECT_UPDATE: "Actualitzat correctament",
      BAD_UPDATE: "No s'ha actualitzat",
      CORRECT_SAVE: "S'ha creat correctament",
      BAD_SAVE: "No s'ha creat correctament",
      LOGIN: "Entrar",
      USER_CODE: "Codi d'usuari",
      LANGUAGE: "Idioma",
      USER: "Usuari",
      PLANIFICATION: "Planificació",
      MACHINES: "Màquines",
      ERROR_RECOVERING_DATA: "Error recuperant les dades",
      MACHINE_NOT_SELECTED: "Màquina no seleccionada",
      OFFLINE: "Desconnectat",
      SELECT: "Seleccionar",
      SELECT_MACHINE: "Selecciona una màquina",
      SELECT_OF: "Selecciona una OF",
      ONLY_ASSIGNED_TO_THIS_MACHINE: "Només assignades a aquesta màquina",
      SHOW_UNASSIGNED: "Incloure no assignades",
      SEARCH_OF: "Cercar OF",
      PREPARE_MACHINE: "Preparar màquina",
      CONNECTION_LOST: "Connexió perduda",
      CONNECTION_LOST_ERROR:
        "S'ha perdut la connexió, l'aplicació no pot funcionar correctament",
      START: "Engegant",
      PROD: "Producció",
      IDLE: "Parada",
      EMERG: "Emergència",
      PREP: "Preparació",
      OF_NUMBER: "Número OF",
      REFERENCE: "Refèrencia",
      PHASE: "Fase",
      PREPARED_BY: "Preparat per",
      SELECT_NEW_OF: "Seleccionar nova OF",
      START_PRODUCTION: "Començar producció",
      START_DATE: "Data d'inici",
      END_DATE: "Data de fi",
      MACHINE: "Màquina",
      OF: "OF",
      QUANTITY: "Quantitat",
      OBSERVATIONS: "Observacions",
      PRODUCTION_SHEET: environment.eurogerm
        ? "Fitxa de producció"
        : "Observacions",
      NO_PRODUCTION_SHEET: environment.eurogerm
        ? "No hi ha fitxa de producció"
        : "No hi ha observacións",
      CLOSE: "Tancar",
      PREPARATION_ENDED: "Preparació finalitzada",
      PRODUCTION_ENDED: "Producció finalitzada",
      NO_PLANIFICATIONS: "Actualment, no té cap planificació",
      SELECT_REFERENCE: "Seleccionar referència",
      MULTIPLE_MACHINES:
        "La OF seleccionada està configurada per produir-se en una altra màquina. A quina màquina voleu produir-la ?",
      COMPONENTS: "Components",
      TIME_PREPARATION: "Temps de preparació",
      TIME_PRODUCTION: "Temps de producció",
      TIME_LEFT: "Temps restant",
      PRODUCED_BY: "Produït per",
      PRODUCTION: "Producció",
      PIECES_OK: "Peces OK",
      PIECES_NOK: "Peces NOK",
      ASSIGN_TO_PRODUCTION: "Assignar a producció",
      ASSIGN_UNASSIGNED: "S'han produït peces fora de producció",
      ASSIGN_UNASSIGNED_MESSAGE:
        "{{count}} peces s'han produït des de l'última producció. La primera peça es va produir el día {{startDate}} i l'última peça es va produir el día {{endDate}}.",
      ASSIGN: "Assignar",
      DISCARD: "Descartar",
      PROTOTYPE: "Prototip",
      PRODUCTION_TYPE: "Tipus de producció",
      JUSTIFY_NOK: "Justificar NOK",
      NOK_JUSTIFIED_PIECES: "NOK peces justificades",
      TOTAL_PIECES_NOK: "Total peces NOK",
      STOP_PRODUCTION: "Finalitzar producció",
      ERROR_STARTING: "Error en iniciar la producció",
      STOP_PREPARATION: "Finalitzar preparació",
      CADENCE: "Cadencia",
      CONTAINER_CODE: environment.eurogerm ? "Codi cicle" : "Codi contenidor",
      CONTAINER: environment.eurogerm ? "Cicle" : "Contenidor",
      START_CONTAINER: "Començar",
      STOP_CONTAINER: environment.eurogerm
        ? "Acabar cicle"
        : "Acabar contenidor",
      MUST_CLOSE_CONTAINER: environment.eurogerm
        ? "Abans de tancar la producció ha de tancar els cicles oberts"
        : "Abans de tancar la producció ha de tancar els contenidors oberts",
      START_CONTAINER_ERROR: environment.eurogerm
        ? "No s'ha pogut iniciar el cicle"
        : "No s'ha pogut iniciar el contenidor",
      STOP_CONTAINER_ERROR: environment.eurogerm
        ? "No s'ha pogut acabar el cicle"
        : "No s'ha pogut acabar el contenidor",
      OF_EMPTY: "Actualment no hi ha cap OF per aquesta màquina",
      NO_OBSERVATIONS: "No hi ha observacións",
      SELF_SIGNED_CERT: "Certificat auto-signat",
      SELF_SIGNED_CERT_MESSAGE:
        "Ha d'acceptar el certificat per a poder comunicar-se amb la màquina",
      DOCUMENTATION: "Documentació",
      NAME: "Nom",
      VIEW_FILE: "Visualitzar arxiu",
      PRINT_LAST_PRODUCTION: "Imprimir última etiqueta",
      CONTROLS: "Controls",
      AS: "Arrencada de sèrie",
      FS: "Fi de sèrie",
      ITU: "Inici de torn",
      DA: "Després d'una avaria",
      PENDING_POINTS: "Qüestionaris de qualitat pendents",
      PENDING_POINT: "Qüestionari de qualitat",
      OF_DE: "de",
      BACK: "Anterior",
      NEXT: "Següent",
      FINISH: "Finalitzar",
      SUBMIT: "Enviar",
      PIECES: "Peces",
      ERROR_STOPPING: "No s'ha pogut acabar la producció",
      EMERGENCY_STOP: "Parada d'emergencia",
      PROPOSE_STOP: "Parada proposada",
      STOP: "Parada",
      SHUTDOWN: "Apagament",
      OTHERS: "Altres",
      MACHINE_ON: "Engegament",
      PREPARATION: "Preparació",
      JUSTIFY_STOPS: "Justificar parades",
      JUSTIFY_STOP: "Justificar parada",
      MANUAL: "Manual",
      STOP_TIME: "Temps de parada",
      JUSTIFY: "Justificar",
      READ: "Llegir",
      QR_CODE: "Codi QR etiqueta",
      ACCEPT_EXPIRED_COMPONENT: "Acceptar component caducat",
      COMPONENT_NAME: "Nom component",
      EXPIRATION: "Caducitat",
      RESPONSIBLE_VALIDATION: "Validació per un responsable",
      RESPONSIBLE_USER_CODE: "Codi usuari responsable",
      ACCEPT: "Acceptar",
      NO_LAST_PRODUCTION: "No s'ha trobat l'última producció",
      NO_LAST_CONTAINER: environment.eurogerm
        ? "No s'ha trobat l'últim cicle"
        : "No s'ha trobat l'últim contenidor",
      DATE: "Data",
      EXTRA_INFORMATION: "Informació extra",
      CONFIGURATION: "Configuració",
      CONNECTING: "Connectant",
      OPEN: "Obert",
      CLOSING: "Tancant",
      CLOSED: "Tancat",
      CURRENT_VERSION: "Versió actual",
      CHANGE: "Canviar",
      CONFIGURATION_PASSWORD: "Contrasenya de configuració",
      INCORRECT_PASSWORD: "Contrasenya incorrecta",
      TRY_AGAIN: "Torna-ho a provar",
      TEAMS: "Equips",
      TEAM: "Equip",
      SELECT_TEAM: "Seleccionar equip",
      WORKERS_NOT_FOUND: "No s'han trobat operaris",
      COMPONENT_INDEX: environment.eurogerm
        ? "Cicle {0} de {1}"
        : "Contenidores {0} de {1}",
      DIVIDE: "Dividir",
      ERROR_UPDATING_MEMBERS: "No s'han pogut actualitzar els membres",
      MODIFY_TEAM: "Modificar equip",
      NO_MACHINES: "No hi ha màquines disponibles",
      OEE: "OEE",
      FAULT: "Averia",
      CORRECTIVE: "Correctiu",
      PREVENTIVE: "Preventiu",
      SELECT_DEVICE_MODE: "Mode",
      MAINTENANCE: "Manteniment",
      AUTOMATIC: "Automàtic",
      DEFAULT_MACHINES: "Màquines predeterminades",
      MAXIMUM_DIFFERENCE_BETWEEN_REPORTED_AND_COUNTED_PIECES:
        "Màxima diferència entre les peces informades i les comptades",
      MAXIMUM_DIFFERENCE_EXCEEDED: "Màxima diferènica superada",
      SHOW_INPUT_KG_UNIT_LOT: "Mostrar input per a kg/unitat i lot",
      KG_UNIT: "kg/unitat",
      LOT: "Lot",
      BOX_CODE: "Codi de box",
      SHOW_BOX_CODE: "Mostra el codi de box",
      SOCKET_LOCAL_DISCONNECTED: "Socket Local Desconnectat",
      SOCKET_LOCAL_DISCONNECTED_ERROR:
        "S'ha perdut la connexió del socket local, l'aplicació no pot funcionar correctament",
      TESTS: "Proves operatives",
      RESPONSIBLE_PRODUCCION: "Responsable Producció",
      END: "Fi",
      NOK: "NOK",
      METERS: "Metres",
      LITERS: "Litres",
      BOXES: "Caixes",
      KG: "Kg",
      SACKS: "Sacs",
      NOK_JUSTIFIED_UNIT: "NOK {{unit}} justificades",
      TOTAL_UNIT_NOK: "Total {{unit}} NOK",
      SHOW_STOP_SCREEN: "Mostrar pantalla de total de parades",
      PER_CYCLE: "per cicle",
      TOTAL_PLANNED_STOPS: "Total de parades previstes",
      INCORRECT_USER_CODE: "Codi d'usuari incorrecte",
      PRODUCTIVITY: "Productivitat",
      SHOW_DIVIDE_CONTAINER: environment.eurogerm
        ? "Mostra dividir cicle"
        : "Mostra dividir contenidor",
      CLOSE_CONTAINER: environment.eurogerm
        ? "Tancar cicle"
        : "Tancar contenidor",
      FROM_PREVIOUS_PRODUCTION: "De produccions anteriors",
      WAITING_BAR_CODE_LECTURE: "Esperant lectura de codi de barres",
      ENTER_CODE_MANUALY: "Entrar codi manualment",
      SELECT_COMPONENT: "Selecciona component",
      LOTS_ENTERED: "Lots entrats",
      QUANTITY_CANT_BE_ZERO: "La quantitat no pot ser 0 o menor que 0",
      QUANTITY_CANT_BE_LESS_ZERO: "La quantitat no pot ser menor que 0",
      QUANTITY_CANT_BE_EDITED: "No s'ha pogut editar la quantitat",
      NO_COMPONENTS: "No hi ha components",
      ERROR_SAVING_DATA: "Error guardant les dades",
      SURE_YOU_WANT_TO_LEAVE: "Segur que vols sortir",
      CHANGES_WILL_NOT_BE_SAVED: "Si has fet canvis, no es guardaran",
      ALL_IN_ONE_CONTAINER: environment.eurogerm
        ? "Tot en un sol cicle"
        : "Tot en un sol conenidor",
      NO_CONTAINERS: environment.eurogerm
        ? "No hi ha cicle disponibles"
        : "No hi ha contenidors disponibles",
      SELECT_NEW_CONTAINER: environment.eurogerm
        ? "Seleccionar nou cicle"
        : "Seleccionar nou contenidor",
      ASK_FOR_MEASURES: "Preguntar per les mesures",
      HIDE_CADENCE: "Amagar cadencia",
      SHOW_CADENCE: "Mostrar cadencia",
      WARNING: "Atenció",
      MACHINE_NOT_READY: "La màquina no està preparada",
      DB_PRINT_TEMPLATE_BUTTON: "Plantilla DB PRINT botó",
      PRODUCTION_START_COMMANDS: "Comandes a enviar en inciar producció",
      MASTER_SLAVE_MODE: "Mode Master/Slave",
      NEXT_CONTAINER_NOT_SCANNED_COMPONENTS: environment.eurogerm
        ? "No s'han verificat els components del pròxim cicle, ha de verificar-los abans de continuar"
        : "No s'han verificat els components del pròxim contenidor, ha de verificar-los abans de continuar",
      ADD_PREPARATION_COMPONENT: "Afegir component de preparació",
      ADD_COMPONENTS: "Afegir components",
      COMPONENT_CODE: "Codi component",
      COMPONENT: "Component",
      USE_PREVIOUS_LOTS: "Utilitzar lots anteriors",
      PREVIOUS_LOTS: "Lots anteriors",
      ADD_PRODUCTION_COMPONENT: "Afegir component",
      TEXT_PRODUCTION_BUTTON: "Text botó de producció",
      TIME_INTERVAL_BUTTON: "Interval de temps botó de producció",
      HIDE_PRODUCTION_DETAIL: "Amagar detall de producció",
      STATION_NAME_REQUIRED: "Es necessita un nom d'estació",
      STATION_NAME_REQUIRED_MSG:
        "Es necessita un nom d'estació abans de crear/modificar una configuració",
      STATION_NAME: "Nom d'estació",
      EXPORT_CONFIGURATION: "Exportar",
      EDIT_CONFIGURATION: "Editar",
      IMPORT_CONFIGURATION: "Importar",
      CONFIGURATIONS: "Configuracions",
      NO_CONFIGURATIONS: "Sense configuracions",
      IMPORT_CONFIGURATION_QUESTION: "Importar configuració?",
      IMPORT_CONFIGURATION_QUESTION_MSG:
        "Desitja importar i sobreescriure la configuració?",
      SAVE: "Guardar",
      SAVE_ALL_LOCAL: "Guardar tot localment",
      GENERAL_TIME_INTERVAL_BUTTON:
        "Interval de temps general de botons de producció",
      VERIFY_COMPONENTS: "Verificar components",
      VERIFY_COMPONENTS_ERROR: "Ha de verificar els components abans",
      DB_PRINT_CONTAINER_TEMPLATE: "Comandes a enviar al tancar un contenidor",
      CLIENT_NOT_CONFIGURED: "Ha de configurar el client",
      THE_SPECIFIED_CONTAINER_DOES_NOT_EXIST: environment.eurogerm
        ? "No existeix el cicle indicat"
        : "No existeix el contenidor indicat",
      NEXT_CONTAINER_CODE: environment.eurogerm
        ? "Codi del següent cicle"
        : "Codi del següent contenidor",
      EMPTY_NEXT_CONTAINER_CODE: environment.eurogerm
        ? "El codi del següent cicle no pot estar buit, si vols acabar la producció fes-ho directament"
        : "El codi del següent contenidor no pot estar buit, si vols acabar la producció fes-ho directament",
      CONTAINERS: environment.eurogerm ? "Cicles" : "Contenidors",
      ACTIVE_CONTAINERS: environment.eurogerm
        ? "Cicles actius"
        : "Contenidors actius",
      PENDING_CONTAINERS: environment.eurogerm
        ? "Cicles pendents"
        : "Contenidors pendents",
      NO_ACTIVE_CONTAINERS: environment.eurogerm
        ? "No hi ha cicles actius"
        : "No hi ha contenidors actius",
      NO_PENDING_CONTAINERS: environment.eurogerm
        ? "No hi ha cicles pendents"
        : "No hi ha contenidors pendents",
      NETWORK_SETTINGS: "Configuració de xarxa",
      EDIT_NETWORK_SETTINGS: "Editar configuració de xarxa",
      PASSWORD: "Contrassenya",
      ADAPTER: "Adaptador",
      ROUND_COUNT: "Arrodonir compte total",
      SELECT_CONTAINER: "Seleccionar contenidor",
      CONTAINERS_EMPTY: "No hi ha contenidors",
      CLOSED_CONTAINERS: "Contenidors tancats",
      CHANGE_OF: "Canviar OF",
      SHOW_CHANGE_OF_BUTTON: 'Mostrar botó "Canviar OF"',
      TOOLING: "Utillatge",
      CHANGE_REFERENCE: "Canviar referència",
      AUTO_START_PRODUCTION_MODE: "Mode d'inici de producció automàtic",
      MINIMUM_CADENCE: "Cadència mínima",
      MINIMUM_TIME: "Temps mínim",
      TOTAL_OF: "Quantitat total OF",
      PRODUCED: "Produïda",
      MUST_START_MASTER_PRODUCTION_BEFORE: 'Ha de començar la producció a la màquina "Master". En cas que las Master estigui engegada, aquesta màquina no té fase configurada per a la OF',
      MASTER_IN_USE: "La màquina \"Master\" està sent utilitzada per un altre operari, comprovi que s'hagin tancat les produccions",
      MUST_CLOSE_PRODUCTION_FROM_MASTER: "Ha de tancar la producció des de la màquina \"Master\"",
      GENERAL:'General',
      CLOUD:'Núvol',
      BUTTONS: 'Botons',
      COMMANDS: 'Comandes',
      SHOW_JUSTIFY_NOK_BUTTON: 'Mostrar botó "Justificar NOK"',
      PRODUCTION_BUTTONS_VISIBLE: 'Botons de producció visibles',
      LOTS: 'Lots',
      LOCATION: 'Ubicació',
      DISABLE_ABILITY_TO_CHANGE_OK_NOK:'Desactivar l\'edició de les quantitats OK/NOK en finalitzar la producció',
      ROUND_COUNT_TO_NEAREST_HALF: "Arrodonir el recompte total al mig",
      SELECT_A_COMPONENT: "Selecciona un component",
      MAN: "Manual",
      MP: "Materia prima",
      TP: "Tipus parada",
      NO_IMAGE_ATTACHED: 'No s\'ha adjuntat imatge',
      IMAGE_ATTACHED: 'Imatge adjuntada',
      CAPTURE_CAMERA: 'Capturar Càmera',
      CAPTURE_IMAGE: 'Capturar imatge',
      SELECT_CAMERA: 'Seleccionar càmera',
      DEVICES: 'Dispositius',
      CAPTURE_SNAPSHOT: 'Capturar instantània',
      ADD_IMAGE: "Afegir imatge",
      AVAILABLE: "Disponible",
      IN_USE: "En ús",
      MACHINE_ALREADY_IN_USE: "La màquina està sent utilitzada per l'usuari {0}",
      OPEN_KEYBOARD: "Obrir teclat"
    },
    FOOTER: {},
  },
};
